"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function htmlToMsgId(html) {
    var result = html.trim().replace(/ data-v-[a-z0-9]+=""/g, '');
    return unescapeEntities(result);
}
exports.default = htmlToMsgId;
function unescapeEntities(html) {
    return html
        .replace('&amp;', '&')
        .replace('&lt;', '<')
        .replace('&gt;', '>');
}
exports.unescapeEntities = unescapeEntities;
//# sourceMappingURL=html_to_msgid.js.map